import { render, staticRenderFns } from "./EditOrgWhitelistDlg.vue?vue&type=template&id=12eeee79"
import script from "./EditOrgWhitelistDlg.vue?vue&type=script&lang=js"
export * from "./EditOrgWhitelistDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports